import hash from 'object-hash';
import useSWR from 'swr';
import { SWRCustomResponse } from '../../../hooks/types';
import { PropertySearchItem } from '../../../providers/api/dtos';
import { PropertiesProviderFilters, searchProperties } from '../../../providers/api/property/propertyProvider';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { useMatchMutate } from '../../../utils/swr/swr';

export const SEARCH_PROPERTIES_RID = '/properties/search';

export default function useSearchProperties(q?: string, filters?: PropertiesProviderFilters, pagination?: PaginationParams): SWRCustomResponse<PaginatedResult<PropertySearchItem>, Error> {
  const matchMutate = useMatchMutate();

  const key = [SEARCH_PROPERTIES_RID, hash({
    q,
    ...(filters || {}),
    ...(pagination || {}),
  })];

  const result = useSWR(key, () => searchProperties(q!, filters, pagination));

  return {
    ...result,
    mutate: () => matchMutate(SEARCH_PROPERTIES_RID),
  };
}
